import React from 'react'

interface IEyeProps {
  readonly size?: number
  readonly lineThrough?: boolean
}

export function Eye({ size = 24, lineThrough = false }: IEyeProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 27 27">
      <path
        data-testid="eye"
        d="M14 6C9 6 4.73 9.11 3 13.5C4.73 17.89 9 21 14 21C19 21 23.27 17.89 25 13.5C23.27 9.11 19 6 14 6ZM14 18.5C11.24 18.5 9 16.26 9 13.5C9 10.74 11.24 8.5 14 8.5C16.76 8.5 19 10.74 19 13.5C19 16.26 16.76 18.5 14 18.5ZM14 10.5C12.34 10.5 11 11.84 11 13.5C11 15.16 12.34 16.5 14 16.5C15.66 16.5 17 15.16 17 13.5C17 11.84 15.66 10.5 14 10.5Z"
      />
      {lineThrough && (
        <rect
          data-testid="eye-line-through"
          x="24"
          y="1.29289"
          width="3"
          height="31.9401"
          transform="rotate(45 24 1.29289)"
        />
      )}
    </svg>
  )
}
